import type {ButtonDocument, PricingSectionSliceModulesAndAddons} from 'prismicio-types'
import {Container} from 'src/common/Container'
import {AddOnsSection} from '../components/AddOnsSection'
import {CTASectionModulesAndAddons} from '../components/CTASectionModulesAndAddons'
import {ModulesSection} from '../components/ModulesSection'

type PricingSectionModulesAndAddonsProps = {
  slice: PricingSectionSliceModulesAndAddons & {
    slice_type: string
    variation: string
  }
  pageUid: string
  componentIndex: number
  buttonsData?: ButtonDocument[]
}

export const PricingSectionModulesAndAddons = ({
  slice,
  pageUid,
  componentIndex,
  buttonsData,
}: PricingSectionModulesAndAddonsProps) => (
  <Container className="!py-10 md:!py-20" backgroundColor="Grey/100">
    <div className="mx-auto flex w-full max-w-[1200px] flex-col gap-10 px-5 md:gap-20 md:px-10 lg:px-5 xl:px-0">
      <ModulesSection header={slice.primary.modules_header[0]} modules={slice.primary.modules} />
      <AddOnsSection header={slice.primary.add_ons_header[0]} addOns={slice.primary.add_ons} />
      <CTASectionModulesAndAddons
        ctaSections={slice.primary.cta_section}
        pageUid={pageUid}
        componentIndex={componentIndex}
        buttonsData={buttonsData}
      />
    </div>
  </Container>
)
